import { Component, h } from 'preact';
import cx from 'classnames';

import { Listing } from 'listing.model';
import { hopplerApi } from '../../../../../constants';
import { InqPropCardPropertySection } from './inq-prop-card-property-section.component';
import { InqPropCardAvailabilitySection } from './inq-prop-card-availability-section.component';

interface InqPropertyCardProps {
  listing?: Listing
  
  inFinalList?: boolean;
  inDetailsCard?: boolean;
  progressStatus?: string;

  showUploader?: boolean;

  onAddToListClick?: (listing: Listing) => void;
  onRemoveFromListClick?: (listing: Listing) => void;
  onProgressUpdate?: (progress: string) => void;
}
export class InqPropertyCard extends Component<InqPropertyCardProps> {
  getImagePath(path: string) {
    if (path) {
      return `${hopplerApi.images}/${path}`;
    } else {
      return hopplerApi.noPhoto;
    }
  }

  getUploaderSection() {
    return (
      <div className="hi-inqpropcard__uploader-group">
        <label className="hi-inqpropcard__uploader-label">Uploader</label>

        <span className="hi-inqpropcard__uploader-name">
          Hopply Uploader Name
        </span>
        <span className="hi-inqpropcard__uploader-number">
          <i className="fas fa-phone" /> 09000000000
        </span>
        <span className="hi-inqpropcard__uploader-email">
          <i className="fas fa-envelope" /> uploader@gmail.com
        </span>
      </div>
    );
  }

  render(props: InqPropertyCardProps) {
    const { listing, inFinalList, inDetailsCard } = props;

    return (
      <div className={ cx('hi-inqpropcard', {
        'hi-inqpropcard--in-final-list': inFinalList,
        'hi-inqpropcard--in-details-card': inDetailsCard
      }) }>
        {/* Image */}
        {/* Property ID (<property group>) */}
        {/* Address (up to 2 lines) */}
        {/* Price */}
        {/* Icon info row (goes below image group on mobile, integrates on desktop) */}
        <InqPropCardPropertySection listing={ listing } />

        {/* ---------------- */}

        {/* MODE-DEPENDENT SECTION */}
        {/* ADD TO LIST MODE */}
        {/* Availability / Inquire updated details (hides on mobile) | Add to list */}
        <InqPropCardAvailabilitySection listing={ listing }
          inFinalList={ props.inFinalList }
          inDetailsCard={ props.inDetailsCard }
          progressStatus={ props.progressStatus }

          onAddToListClick={ this.props.onAddToListClick }
          onRemoveFromListClick={ props.onRemoveFromListClick }
          onProgressUpdate={ props.onProgressUpdate } />

        {/* Date updated group -- hidden until rules are clarified */}
        {/* { this.getUploaderSection() } */}
        
      </div>
    )
  }
}
